/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { Owner } from "../../../models/owner.model"
import { Payment, PaymentStatus } from "../../../models/payment.model"
import { Tenant } from "../../../models/tenant.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { BILLING_ENDPOINT } from "../billing.endpoint"

let tenantCollection: CollectionQuery
let tenantCountCollection: CollectionQuery
let ownersOfTenantCollection: CollectionQuery
let archivedTenantCollection: CollectionQuery
const billingQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getBilling: builder.query<Payment, string>({
      query: (id: string) => ({
        url: `${BILLING_ENDPOINT.detail}/${id}`,
        method: "GET",
        // params: collectionQueryBuilder(data),
      }),
      providesTags: ["Payment"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   PaymentCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    getBillings: builder.query<Collection<Payment>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${BILLING_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Payments"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   PaymentCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countBillings: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${BILLING_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Payments"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   PaymentCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getArchivedBilling: builder.query<Payment, string>({
      query: (id: string) => ({
        url: `${BILLING_ENDPOINT.archivedPayment}/${id}`,
        method: "get",
      }),
      providesTags: ["Archived Payment"],
    }),

    getArchivedBillings: builder.query<Collection<Payment>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${BILLING_ENDPOINT.archivedPayments}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Archived Payments"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   archivedPaymentCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    createBilling: builder.mutation<Payment, any>({
      query: (newData: any) => ({
        url: `${BILLING_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-payments",
      }),
      invalidatesTags: ["Payments", "Count Payments"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateBilling: builder.mutation<Payment, any>({
      query: (newData: any) => ({
        url: `${BILLING_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((Payment) => {
            //           if (Payment.id === data.id) return data
            //           else {
            //             return Payment
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    changeBillingStatus: builder.mutation<
      Payment,
      { id: string; data: FormData }
    >({
      query: (data: { id: string; data: FormData }) => ({
        url: `${BILLING_ENDPOINT.changePaymentStatus}`,
        method: "post",
        permission: "manage-payments",
        data: data.data,
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((Payment: Payment) => {
            //           if (Payment.id === data.id) return data
            //           else {
            //             return Payment
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   billingQuery.util.updateQueryData("getPayment", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archiveBilling: builder.mutation<Payment, { id: string; reason: string }>({
      query: (data) => ({
        url: `${BILLING_ENDPOINT.archive}`,
        method: "delete",
        data: data,
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((Payment) => {
            //         if (Payment.id === arg.id) {
            //           return data
            //         } else {
            //           return Payment
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getPayment",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getArchivedPayment",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully archived")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    payForOwnerBillManually: builder.mutation<
      any,
      { paymentId: string; data: FormData }
    >({
      query: (data: { paymentId: string; data: FormData }) => ({
        url: `${BILLING_ENDPOINT.payForOwnerBillManually}`,
        method: "post",
        data: data.data,
        // permission: "manage-permissions",
      }),
      invalidatesTags: ["Payment", "Payments"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   leaseQuery.util.updateQueryData(
            //     "getLeases",
            //     leaseCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((provider) => {
            //         if (provider.id === id) {
            //           return data
            //         } else {
            //           return provider
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   leaseQuery.util.updateQueryData("getLease", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )

            notification("success", "Successfully Paid")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    deleteBilling: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${BILLING_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getArchivedPayments",
            //     archivedPaymentCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((Payment) => Payment.id !== id)
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restoreBilling: builder.mutation<Payment, string>({
      query: (id: string) => ({
        url: `${BILLING_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-payments",
      }),
      invalidatesTags: ["Payment", "Payments", "Count Payments"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getPayments",
            //     PaymentCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((Payment) => {
            //         if (Payment.id === id) {
            //           return data
            //         } else {
            //           return Payment
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   billingQuery.util.updateQueryData("getPayment", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   billingQuery.util.updateQueryData(
            //     "getArchivedPayment",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
  }),
  overrideExisting: true,
})
export const {
  useLazyGetBillingQuery,
  useLazyCountBillingsQuery,
  useLazyGetArchivedBillingQuery,
  useLazyGetArchivedBillingsQuery,
  useLazyGetBillingsQuery,
  useCreateBillingMutation,
  useDeleteBillingMutation,
  useUpdateBillingMutation,
  useArchiveBillingMutation,
  useRestoreBillingMutation,
  useChangeBillingStatusMutation,
  usePayForOwnerBillManuallyMutation,
} = billingQuery
